import * as React from "react";
import { SVGProps } from "react";
export function VolunteerWorkIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 19.518 18.862"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m9.759 18.005-7.5-7.943c-4.2-4.686 1.85-13.772 7.5-6.457 5.65-7.315 11.7 1.771 7.5 6.457l-7.5 7.943Z"
        stroke="#000"
        strokeWidth={1.714}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
